const domainsForCaptcha = [
  "betclub7",
  // "cartola",
  "betpremier",
  "pingolbet",
  "betpix",
  "dasorte",
  "betdasorte",
  "jogodeouro",
  "jogodeourobet",
  "podersports",
  "pagamaissports",
  "pixpremioesporte",
  "donosdabola",
  "overbets",
  "bets88",
  "betgol777",
  "nbet91",
  "esportenet",
];

export default domainsForCaptcha;